import { httpClient } from 'utils/httpClient';
import {
  NotificacionRequest,
  NotificacionMia,
  NotificacionAdmin,
} from 'types/notificacion.types';

export const notificacionService = {
  /** POST /notificaciones — ADMIN, DIRECTOR, SECRETARIA, DOCENTE */
  async crear(payload: NotificacionRequest): Promise<NotificacionAdmin> {
    return httpClient.post<NotificacionAdmin>('/notificaciones', payload);
  },

  /** GET /notificaciones/mias — cualquier usuario autenticado */
  async getMias(): Promise<NotificacionMia[]> {
    return httpClient.get<NotificacionMia[]>('/notificaciones/mias');
  },

  /** PATCH /notificaciones/:id/leer */
  async marcarLeida(id: number): Promise<NotificacionMia> {
    return httpClient.patch<NotificacionMia>(`/notificaciones/${id}/leer`, {});
  },

  /** PATCH /notificaciones/:id/confirmar — padre confirma recepción de comunicado */
  async confirmar(id: number): Promise<NotificacionMia> {
    return httpClient.patch<NotificacionMia>(`/notificaciones/${id}/confirmar`, {});
  },

  /** GET /notificaciones/admin — solo ADMIN */
  async getAdmin(): Promise<NotificacionAdmin[]> {
    return httpClient.get<NotificacionAdmin[]>('/notificaciones/admin');
  },

  /** DELETE /notificaciones/:id — solo ADMIN (soft delete) */
  async desactivar(id: number): Promise<void> {
    return httpClient.delete<void>(`/notificaciones/${id}`);
  },
};
